import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { StateService } from '@uirouter/angular';
import { FrontEndService } from '../../services/front-end.service';


@Component({
  selector: 'app-sidebarmenu',
  templateUrl: './sidebarmenu.component.html',
  styleUrls: ['./sidebarmenu.component.scss']
})
export class SidebarmenuComponent implements OnInit {
  @Input() current_state = '';
  public isCollapsed = true;
  public mobileCollapsed = true;
  public hubCollapsed = true;
  public subMenuEnterPrice = true;
  main_dashboard = "";
  verifyProduct = "";
  checkCoupon = "";
  redeemProduct = "";
  transactionHistory = "";
  reportIncident = "";
  fakeReport = "";
  feedBack = "";
  coreAppActive = "";
  preCheck = "";

  constructor(
    public dataService: DataService,
    private stateService: StateService,
    private frontEndService: FrontEndService
  ){}

  ngOnInit() {

    // this.logService.printLog("test menu -", this.current_state);
    this.menuActive();
    
    
  }
  logOut() {
    localStorage.clear();
    // this.logService.printLog('clear localstorage');
    this.stateService.go('landing'); 
  }

  // profile() {
  //   this.stateService.go('profile');
  // }


  // menuSelect() {
  //   this.logService.printLog("sadugdsaiusad");
  //   // alert("hi");
  // }

  menuActive(){
    switch(this.current_state){
      case 'dashboard':
        this.main_dashboard = "active";
        break;
      case 'verify-product':
        this.verifyProduct = "active";
        this.coreAppActive = "main-menu-active";
        break;
      case 'coupon-product':
        this.checkCoupon = "active";
        this.coreAppActive = "main-menu-active";
        break;
      case 'redeem-coupon':
        this.redeemProduct = "active";
        this.coreAppActive = "main-menu-active";
        break;
      case "transaction-history":
        this.transactionHistory = "active";
        this.coreAppActive = "main-menu-active";
        break;
      case "report-incident":
        this.reportIncident = "active";
        this.coreAppActive = "main-menu-active";
        break;
      case "report-fake-product":
        this.fakeReport = "active";
        this.coreAppActive = "main-menu-active";
        break;
      case "feedback":
        this.feedBack = "active";
        this.coreAppActive = "main-menu-active";
        break;
      case "precheck-product":
        this.preCheck = "active";
        this.coreAppActive = "main-menu-active";
        break;
    }
  }
  showMsg() {
    this.frontEndService.sweetAlert("Info", "Contact your account manager to configure this solution before it can be used.", "info");
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/sidebarmenu/sidebarmenu.component.ts